module["exports"] = [
  "###-###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/address/postcode.js
// module id = 1287
// module chunks = 1